import { IPSelectableOption } from 'baseComponents';
import { t } from 'i18next';
import { ProcessingActivityRole, ProcessingActivityState } from 'models/processingActivity';

export const getProcessingActivityRoleOptions = (): IPSelectableOption[] => {
  const items: IPSelectableOption[] = [
    {
      key: ProcessingActivityRole.Controller,
      text: t('processingActivity:Role.Controller'),
      data: ProcessingActivityRole.Controller,
    },
    {
      key: ProcessingActivityRole.Processor,
      text: t('processingActivity:Role.Processor'),
      data: ProcessingActivityRole.Processor,
    },
  ];

  return items;
};

export const getProcessingActivityStateOptions = (): IPSelectableOption[] => {
  const items: IPSelectableOption[] = [
    {
      key: ProcessingActivityState.Concept,
      text: t('processingActivity:State.Concept'),
      data: ProcessingActivityState.Concept,
    },
    {
      key: ProcessingActivityState.Approved,
      text: t('processingActivity:State.Approved'),
      data: ProcessingActivityState.Approved,
    },
    {
      key: ProcessingActivityState.Archived,
      text: t('processingActivity:State.Archived'),
      data: ProcessingActivityState.Archived,
    },
    {
      key: ProcessingActivityState.Review,
      text: t('processingActivity:State.Review'),
      data: ProcessingActivityState.Review,
    },
    {
      key: ProcessingActivityState.AwaitingApproval,
      text: t('processingActivity:State.AwaitingApproval'),
      data: ProcessingActivityState.AwaitingApproval,
      disabled: true,
    }
  ];

  return items;
};
